const SpotOnSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.48" height="29.003">
      <g data-name="グループ 58" fill="none" stroke-miterlimit="10">
        <g data-name="パス 61">
          <path d="M10.24-.001A10.28 10.28 0 000 10.239c-.054 5.011 5.3 13.43 8.288 17.729a2.4 2.4 0 003.932.018c2.977-4.211 8.26-12.434 8.26-17.747A10.239 10.239 0 0010.24-.001z" />
          <path
            d="M10.24 2a8.131 8.131 0 00-5.8 2.41A8.371 8.371 0 002 10.262c-.014 1.28.457 3.738 2.777 8.185C6.445 21.643 8.5 24.77 9.93 26.828c.1.144.236.175.331.175.094 0 .226-.03.326-.17 1.415-2.003 3.45-5.056 5.106-8.231 2.303-4.417 2.787-6.985 2.787-8.362 0-4.543-3.696-8.24-8.24-8.24m0-2c5.656 0 10.24 4.584 10.24 10.24 0 5.313-5.283 13.536-8.26 17.747a2.399 2.399 0 01-3.932-.018C5.302 23.669-.054 15.251 0 10.24.062 4.585 4.585 0 10.24 0z"
            className="main-fill"
          />
        </g>
        <g data-name="楕円形 66" transform="translate(5.189 5.262)" className="main-stroke" stroke-width="2">
          <circle cx="5.051" cy="5.051" r="5.051" stroke="none" />
          <circle cx="5.051" cy="5.051" r="4.051" />
        </g>
      </g>
    </svg>
  )
}

export default SpotOnSvg
